export enum DialogResults {
    CONFIRM ,
    CANCEL ,
    REQUEST_CHANGES,
    SAVE_FOR_LATER,
    APPROVE
}